import { makeStyles, tokens } from "@fluentui/react-components";

export const usePageContainerStyles = makeStyles({
  root: {
    width: "100%",
    boxSizing: "border-box",
    padding: `${tokens.spacingVerticalM} ${tokens.spacingVerticalL}`,
  },
});
